// components
import React from 'react'

import 'core-js/stable/symbol'
import 'core-js/stable/symbol/iterator'
import 'core-js/es/promise'
import 'core-js/es/string/raw'
import 'core-js/es/string/ends-with'
import 'core-js/es/string/starts-with'
import 'core-js/es/string/iterator'
import 'core-js/es/string/replace-all'
import 'core-js/es/array/find'
import 'core-js/es/array/map'
import 'core-js/es/array/reduce'
import 'core-js/es/array/reverse'
import 'core-js/es/array/some'
import 'core-js/es/array/values'
import 'core-js/es/array/concat'
import 'core-js/es/array/every'
import 'core-js/es/array/flat'
import 'core-js/es/array/index-of'
import 'core-js/es/array/find-index'
import 'core-js/es/array/from'
import 'core-js/es/object/keys'
import 'core-js/es/object/assign'
import 'core-js/es/object/to-string'
import 'core-js/es/typed-array'
import 'core-js/es/date'
import 'core-js/es/regexp'

import 'regenerator-runtime/runtime'
import 'custom-event-polyfill'
import loadable from '@loadable/component'

import {
  constants,
  hydrate,
  createDocomoUrl,
  CommonTranslations
} from '@pdrj/pmi-iqos-shared-react'

const fallback = <div className="loading loading-lg" />
const context = 'iqosphere'

const AddressConfirmation = loadable(
  () =>
    import(
      /* webpackChunkName: "AddressConfirmation" */ './components/address-confirmation'
    ),
  { fallback }
)

const AVConversion = loadable(
  () =>
    import(/* webpackChunkName: "AVConversion" */ './components/av-conversion'),
  { fallback }
)

const ASDRegistration = loadable(
  () =>
    import(
      /* webpackChunkName: "ASDRegistration" */ './components/asd-registration'
    ),
  { fallback }
)

const Campaign = loadable(
  () => import(/* webpackChunkName: "Campaign" */ './components/campaign'),
  { fallback }
)

const DailyPrizes = loadable(
  () =>
    import(/* webpackChunkName: "DailyPrizes" */ './components/daily-prizes'),
  { fallback }
)

const DeviceRegistration = loadable(
  () =>
    import(
      /* webpackChunkName: "DeviceRegistration" */ './components/device-registration'
    ),
  { fallback }
)

const EarnQoins = loadable(
  () => import(/* webpackChunkName: "EarnQoins" */ './components/earn-qoins'),
  { fallback }
)

const EventDigitalPasses = loadable(
  () =>
    import(
      /* webpackChunkName: "EventDigitalPasses" */ './components/event-digital-passes'
    ),
  { fallback }
)

const Login = loadable(
  () => import(/* webpackChunkName: "Login" */ './components/login'),
  { fallback }
)

const Logout = loadable(
  () => import(/* webpackChunkName: "Logout" */ './components/logout'),
  { fallback }
)

const LotteryProductDetail = loadable(
  () =>
    import(
      /* webpackChunkName: "LotteryProductDetail" */ './components/lottery-product-detail'
    ),
  { fallback }
)

const LotteryProductList = loadable(
  () =>
    import(
      /* webpackChunkName: "LotteryProductList" */ './components/lottery-product-list'
    ),
  { fallback }
)

const OpinionPoll = loadable(
  () =>
    import(/* webpackChunkName: "OpinionPoll" */ './components/opinion-poll'),
  { fallback }
)

const PrizeDetail = loadable(
  () =>
    import(/* webpackChunkName: "PrizeDetail" */ './components/prize-detail'),
  { fallback }
)

const EarnPoints = loadable(
  () => import(/* webpackChunkName: "EarnPoints" */ './components/earn-points'),
  { fallback }
)

const PointsList = loadable(
  () => import(/* webpackChunkName: "PointsList" */ './components/points-list'),
  { fallback }
)

const ProfileAccountForms = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileAccountForms" */ './components/profile-account-forms'
    ),
  { fallback }
)

const ProfileAvatar = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileAvatar" */ './components/profile-avatar'
    ),
  { fallback }
)

const ProfileMembershipCard = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileMembershipCard" */ './components/profile-membership-card'
    ),
  { fallback }
)

const ProfileMembershipCardView = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileMembershipCardView" */ './components/profile-membership-card-view'
    ),
  { fallback }
)

const ProfilePrizes = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfilePrizes" */ './components/profile-prizes'
    ),
  { fallback }
)

const ProfileSocialAccounts = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileSocialAccounts" */ './components/profile-social-accounts'
    ),
  { fallback }
)

const ProfileNotices = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileNotices" */ './components/profile-notices'
    ),
  { fallback }
)

const ProfilePoints = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfilePoints" */ './components/profile-points'
    ),
  { fallback }
)

const ProfileUnverifiedBanner = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileUnverifiedBanner" */ './components/profile-unverified-banner'
    ),
  { fallback }
)

const ProfilesLoginCallback = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfilesLoginCallback" */ './components/profiles-login-callback'
    ),
  { fallback }
)

const QoinsBadge = loadable(
  () => import(/* webpackChunkName: "QoinsBadge" */ './components/qoins-badge'),
  { fallback }
)

const Quest = loadable(
  () => import(/* webpackChunkName: "Quest" */ './components/quest'),
  { fallback }
)

const QuestList = loadable(
  () => import(/* webpackChunkName: "QuestList" */ './components/quest-list'),
  { fallback }
)

const Quiz = loadable(
  () => import(/* webpackChunkName: "Quiz" */ './components/quiz'),
  { fallback }
)

const Select = loadable(
  () => import(/* webpackChunkName: "Select" */ './components/select'),
  { fallback }
)

const SpinWheel = loadable(
  () => import(/* webpackChunkName: "SpinWheel" */ './components/spin-wheel'),
  { fallback }
)

const Spots = loadable(
  () => import(/* webpackChunkName: "Spots" */ './components/spots'),
  { fallback }
)

const StarterPack = loadable(
  () =>
    import(/* webpackChunkName: "StarterPack" */ './components/starter-pack'),
  { fallback }
)

const PointsBadge = loadable(
  () =>
    import(/* webpackChunkName: "PointsBadge" */ './components/points-badge'),
  { fallback }
)

const TermsPopup = loadable(
  () => import(/* webpackChunkName: "TermsPopup" */ './components/terms-popup'),
  { fallback }
)

const QRCodeCard = loadable(
  () =>
    import(/* webpackChunkName: "QRCodeCard" */ './components/qr-code-card'),
  { fallback }
)

const VideoQuiz = loadable(
  () => import(/* webpackChunkName: "VideoQuiz" */ './components/video-quiz'),
  { fallback }
)

// translations
const AddressConfirmationTranslations = require('./components/address-confirmation/address-confirmation.json')
const AVConversionTranslations = require('./components/av-conversion/av-conversion.json')
const ASDRegistrationTranslations = require('./components/asd-registration/asd-registration.json')
const CampaignTranslations = require('./components/campaign/campaign.json')
const DailyPrizesTranslations = require('./components/daily-prizes/daily-prizes.json')
const DeviceRegistrationTranslations = require('./components/device-registration/device-registration.json')
const EarnQoinsTranslations = require('./components/earn-qoins/earn-qoins.json')
const EventDigitalPassesTranslations = require('./components/event-digital-passes/event-digital-passes.json')
const LoginTranslations = require('./components/login/login.json')
const LogoutTranslations = require('./components/logout/logout.json')
const LotteryProductDetailTranslations = require('./components/lottery-product-detail/lottery-product-detail.json')
const LotteryProductListTranslations = require('./components/lottery-product-list/lottery-product-list.json')
const OpinionPollTranslatinos = require('./components/opinion-poll/opinion-poll.json')
const PrizeDetailTranslations = require('./components/prize-detail/prize-detail.json')
const EarnPointsTranslations = require('./components/earn-points/earn-points.json')
const PointsListTranslations = require('./components/points-list/points-list.json')
const ProfileAccountFormsTranslations = require('./components/profile-account-forms/profile-account-forms.json')
const ProfileAvatarTranslations = require('./components/profile-avatar/profile-avatar.json')
const ProfileMembershipCardTranslations = require('./components/profile-membership-card/profile-membership-card.json')
const ProfileMembershipCardViewTranslations = require('./components/profile-membership-card-view/profile-membership-card-view.json')
const ProfilePrizesTranslations = require('./components/profile-prizes/profile-prizes.json')
const ProfileSocialAccountsTranslations = require('./components/profile-social-accounts/profile-social-accounts.json')
const ProfileNoticesTranslations = require('./components/profile-notices/profile-notices.json')
const ProfilePointsTranslations = require('./components/profile-points/profile-points.json')
const ProfileUnverifiedBannerTranslations = require('./components/profile-unverified-banner/profile-unverified-banner.json')
const ProfilesLoginCallbackTranslations = require('./components/profiles-login-callback/profiles-login-callback.json')
const QoinsBadgeTranslations = require('./components/qoins-badge/qoins-badge.json')
const QuestTranslations = require('./components/quest/quest.json')
const QuestListTranslations = require('./components/quest-list/quest-list.json')
const QuizTranslations = require('./components/quiz/quiz.json')
const SelectTranslations = require('./components/select/select.json')
const SpinWheelTranslations = require('./components/spin-wheel/spin-wheel.json')
const SpotsTranslations = require('./components/spots/spots.json')
const StarterPackTranslations = require('./components/starter-pack/starter-pack.json')
const PointsBadgeTranslations = require('./components/points-badge/points-badge.json')
const TermsPopupTranslations = require('./components/terms-popup/terms-popup.json')
const VideoQuizTranslations = require('./components/video-quiz/video-quiz.json')
const QRCodeCardTranslations = require('./components/qr-code-card/qr-code-card.json')

export default {
  components: {
    AddressConfirmation,
    AVConversion,
    ASDRegistration,
    Campaign,
    DailyPrizes,
    DeviceRegistration,
    EarnQoins,
    EventDigitalPasses,
    Login,
    Logout,
    LotteryProductDetail,
    LotteryProductList,
    OpinionPoll,
    PrizeDetail,
    EarnPoints,
    PointsList,
    ProfileAccountForms,
    ProfileAvatar,
    ProfileMembershipCard,
    ProfileMembershipCardView,
    ProfilePrizes,
    ProfileSocialAccounts,
    ProfileNotices,
    ProfilePoints,
    ProfileUnverifiedBanner,
    ProfilesLoginCallback,
    QoinsBadge,
    Quest,
    QuestList,
    Quiz,
    Select,
    SpinWheel,
    Spots,
    StarterPack,
    PointsBadge,
    TermsPopup,
    VideoQuiz,
    QRCodeCard
  },
  translations: {
    AddressConfirmation: AddressConfirmationTranslations,
    AVConversion: AVConversionTranslations,
    ASDRegistration: ASDRegistrationTranslations,
    Campaign: CampaignTranslations,
    Common: CommonTranslations,
    DailyPrizes: DailyPrizesTranslations,
    DeviceRegistration: DeviceRegistrationTranslations,
    EarnQoins: EarnQoinsTranslations,
    EventDigitalPasses: EventDigitalPassesTranslations,
    Login: LoginTranslations,
    Logout: LogoutTranslations,
    LotteryProductDetail: LotteryProductDetailTranslations,
    LotteryProductList: LotteryProductListTranslations,
    OpinionPoll: OpinionPollTranslatinos,
    PrizeDetail: PrizeDetailTranslations,
    EarnPoints: EarnPointsTranslations,
    PointsList: PointsListTranslations,
    ProfileAccountForms: ProfileAccountFormsTranslations,
    ProfileAvatar: ProfileAvatarTranslations,
    ProfileMembershipCard: ProfileMembershipCardTranslations,
    ProfileMembershipCardView: ProfileMembershipCardViewTranslations,
    ProfilePrizes: ProfilePrizesTranslations,
    ProfileSocialAccounts: ProfileSocialAccountsTranslations,
    ProfileNotices: ProfileNoticesTranslations,
    ProfilePoints: ProfilePointsTranslations,
    ProfileUnverifiedBanner: ProfileUnverifiedBannerTranslations,
    ProfilesLoginCallback: ProfilesLoginCallbackTranslations,
    QoinsBadge: QoinsBadgeTranslations,
    Quest: QuestTranslations,
    QuestList: QuestListTranslations,
    Quiz: QuizTranslations,
    Select: SelectTranslations,
    SpinWheel: SpinWheelTranslations,
    Spots: SpotsTranslations,
    StarterPack: StarterPackTranslations,
    PointsBadge: PointsBadgeTranslations,
    TermsPopup: TermsPopupTranslations,
    VideoQuiz: VideoQuizTranslations,
    QRCodeCard: QRCodeCardTranslations
  },
  hydrate,
  version: process.env.VERSION,
  cdnReactDistUrl: constants.CDN_REACT_DIST_URL + '/' + context,
  utils: {
    createDocomoUrl
  }
}
